export default {
  inquiryQuote: {
    title: 'Inquiry & Quote',
    detailTitle: 'Inquiry & Quote Detail',
    createTitle: 'Create Inquiry',
    editTitle: 'Edit Inquiry',

    filters: {
      inquiryNo: 'Inquiry No.',
      source: 'Inquiry Source',
      quoteSource: 'Quote Source',
      quoteStatus: 'Quote Status',
      consultationStatus: 'Consultation Status',
      salesQuoterId: 'Sales Quoter',
      businessQuoterIds: 'Business Quoter',
      inquiryTargetIds: 'Supplier',
      inquirerId: 'Inquirer',
      clientId: 'Inquiry Client',
      all: 'All'
    },

    options: {
      sourceInternal: 'Internal',
      sourceClient: 'Client',
      sourceAgentWecom: 'WeCom Agent',
      sourceCargowareXAgent: 'CargowareX Agent',
      sourceEmailAgent: 'Email Agent',
      sourceFamilyAgent: 'Family Agent',
      /** @deprecated legacy labels */
      sourceCustomer: 'External',
      sourceInternalSales: 'Internal',
      sourceWallTechFamily: 'Entrusted',
      quoteSourceSales: 'Sales Quote',
      quoteSourceBusiness: 'Business Quote',
      quoteSourceSupplier: 'Supplier Quote',
      quoteStatusPendingSales: 'Pending Sales Quote',
      quoteStatusPendingBusiness: 'Pending Business Quote',
      quoteStatusPendingSupplier: 'Pending Supplier Quote',
      quoteStatusQuoted: 'Quoted',
      quoteStatusPending: 'Pending Quote',
      quoteStatusNotQuoted: 'Not Quoted',
      consultationNone: 'Not Consulted',
      consultationInProgress: 'In Consultation',
      consultationDone: 'Consultation Completed',
      intentionYes: 'Interested',
      intentionNo: 'Not Interested',
      intentionConsidering: 'Considering',
      intentionOrder: 'Intent Order',
      direct: 'Direct',
      transit: 'Transit'
    },

    bizTabs: {
      sea: 'Ocean',
      air: 'Air',
      rail: 'Rail',
      prePort: 'Pre-carriage',
      lastMile: 'On-carriage'
    },

    toolbar: {
      create: 'Create Inquiry',
      query: 'Search',
      reset: 'Reset',
      totalSummary: '{inquiryCount} inquiries, {quoteCount} quote records',
      columnSettings: 'Columns',
      selectAll: 'Select All',
      cancelSelect: 'Clear',
      inquiryInfo: 'Inquiry Info',
      salesQuoteInfo: 'Sales Quote Info',
      businessQuoteInfo: 'Business Quote Info',
      supplierQuoteInfo: 'Supplier Quote Info',
      salesQuoteDetail: 'Sales Quote Details',
      businessQuoteDetail: 'Business Quote Details',
      supplierQuoteDetail: 'Supplier Quote Details',
      actions: 'Actions',
      carrier: 'Carrier',
      cargoType: 'Cargo Type',
      transportMode: 'Transport Mode',
      segmentPrePort: 'Pre-carriage',
      segmentTrunk: 'Main Leg',
      segmentLastMile: 'On-carriage'
    },

    columns: {
      inquiryNo: 'Inquiry No.',
      inquiryNoTip: 'System-generated inquiry code',
      source: 'Inquiry Source',
      sourceTip: 'Matches backend inquiry source: Internal / Client / WeCom Agent / CargowareX Agent / Email Agent / Family Agent',
      userId: 'Inquirer',
      userIdTip: 'Inquirer name and enterprise',
      inquirerName: 'Inquirer Name',
      inquirerPhone: 'Inquirer Phone',
      inquirerPhoneTip: 'Auto-filled from login account or entered on create',
      inquirerEmail: 'Inquirer Email',
      inquirerEmailAlt: 'Inquirer Mail',
      inquirerEmailTip: 'Auto-filled from login account or entered on create',
      inquiryTime: 'Inquiry Time',
      inquiryTimeTip: 'Time when inquiry data was received',
      cargoReadyTime: 'Cargo Ready Time',
      cargoReadyTimeTip: 'Entered when submitting inquiry',
      etd: 'Expected ETD',
      etdTip: 'Entered when submitting inquiry',
      palletNature: 'Pallet Nature',
      palletNatureTip: 'Entered when submitting inquiry',
      quoteDeadline: 'Quote Deadline',
      quoteDeadlineTip: 'Entered when submitting inquiry',
      cargoValueDisplay: 'Cargo Value (Currency)',
      cargoValueDisplayTip: 'Cargo value amount and currency',
      directTransit: 'Direct / Transit',
      directTransitTip: 'Direct or transit',
      transitPoint: 'Transit Point',
      transitPointTip: 'Transit station; empty when direct',
      salesQuoterName: 'Sales Quoter',
      salesQuoterNameTip: 'salesQuoterId on inquiry',
      salesQuoteStatus: 'Sales Quote Status',
      salesQuoteStatusTip: '0-None / 1-Pending / 2-Quoted',
      businessQuoterName: 'Business Quoter',
      businessQuoterNameTip: 'businessQuoterIds; collapse as primary +N',
      businessQuoteStatus: 'Business Quote Status',
      businessQuoteStatusTip: '0-None / 1-Pending / 2-Quoted',
      supplierQuoterName: 'Supplier',
      supplierQuoterNameTip: 'inquiryTargetIds; collapse as primary +N',
      supplierQuoteStatus: 'Supplier Quote Status',
      supplierQuoteStatusTip: '0-None / 1-Pending / 2-Quoted',
      inquiryPath: 'Inquiry Path',
      inquiryPathTip: 'Place of receipt → POL → POD → Place of delivery'
    },

    roleColumns: {
      businessQuoteNo: 'Business Quote No.',
      businessPrice: 'Business Price',
      salesQuoteNo: 'Sales Quote No.',
      salesPrice: 'Sales Price',
      supplierQuoteNo: 'Supplier Quote No.',
      supplierPrice: 'Supplier Price',
      orderIntention: 'Order Intention',
      carrier: 'Carrier',
      placeOfReceipt: 'Place of Receipt',
      pol: 'POL',
      pod: 'POD',
      placeOfDelivery: 'Place of Delivery',
      transitPort: 'Transit Port',
      consultationStatus: 'Consultation Status',
      quoteTime: 'Quote Time',
      priceDetails: 'Price Details',
      remark: 'Remarks'
    },

    actions: {
      detail: 'Detail',
      edit: 'Edit',
      create: 'Create Inquiry'
    },

    messages: {
      loadFailed: 'Failed to load inquiry & quote data'
    },

    empty: {
      noInquiry: 'No inquiry records'
    },

    autoQuote: {
      status: {
        enabled: 'Auto quote is enabled: quotes are generated immediately when matching rates exist in the Sales Quote tab',
        disabled: 'Auto quote is disabled: matching rates must be selected manually (Personal Settings → Quote Settings)',
        strategy: ' (Strategy: {strategy})',
        newInquiryOnly: ' (New inquiries only)',
        goToSettings: 'Settings'
      },
      settings: {
        title: 'Quote Settings',
        enable: 'Auto Quote',
        enableDescription: 'When enabled, a quote is generated immediately if a matching rate exists in the Sales Quote tab. This only applies to new inquiries received after enabling.',
        strategy: 'Default Quote Strategy',
        strategyDescription: 'Select the rate used for auto quote when multiple matching rates exist',
        lowestTotal: 'Lowest total first — select the rate with the lowest total when multiple rates match',
        ownedRateFirst: 'Owned rates first — prefer maintained rates from the rate library',
        latestRateFirst: 'Latest rates first — prefer the latest listed matching rate',
        strategyNames: {
          lowestTotal: 'Lowest total first',
          ownedRateFirst: 'Owned rates first',
          latestRateFirst: 'Latest rates first'
        },
        save: 'Save Settings',
        saved: 'Settings saved',
        loadFailed: 'Failed to load auto quote settings',
        saveFailed: 'Failed to save auto quote settings',
        descriptionTitle: 'About Auto Quote',
        removedDelayTitle: 'No scheduled delay: ',
        removedDelay: 'The delay timer is no longer used. Auto quote is controlled only by the switch above.',
        immediateTitle: 'Immediate quote: ',
        immediate: 'When enabled, a system quote is generated immediately for a new inquiry with a matching rate, without manual action.',
        newInquiryTitle: 'New inquiries only: ',
        newInquiry: 'The setting applies only to inquiries received after it is saved. Existing quotes are not modified.',
        followUpTitle: 'Follow-up: ',
        followUp: 'Auto quotes enter the same quote data and follow-up flow as manual quotes, allowing sales to continue customer communication.'
      }
    },

    detail: {
      title: 'Inquiry & Quote Detail',
      inquiryInfo: 'Inquiry Info',
      quoteInfo: 'Quote Info',
      tabs: {
        sales: 'Sales Quote ({count})',
        business: 'Business Quote ({count})'
      },
      sections: {
        quoteData: 'Quote Data',
        businessQuoteData: 'Business Quote Data',
        supplierQuoteData: 'Supplier Quote Data',
        recommendedRates: 'Recommended Rates',
        notQuotedYet: 'Not quoted yet',
        countItems: '{count} items',
        notQuoted: 'Not quoted'
      },
      actions: {
        selectRate: 'Select Rate',
        inquireBusiness: 'Inquire Business',
        inquireSupplier: 'Inquire Supplier',
        submitQuote: 'Submit Quote',
        submitQuoteWithCount: 'Submit Quote ({count})',
        createQuoteManually: 'Create Quote Manually',
        viewDetail: 'View Detail',
        negotiate: 'Negotiate',
        negotiationHistory: 'Negotiation History'
      },
      tips: {
        salesTab:
          'Multi-select rates from the published rate library (with sailing and all-in options), or inquire business for a quote; submit after selecting business quotes / recommended rates',
        salesTabAir:
          'Multi-select rates from the published rate library (with all-in option), or inquire business for a quote; submit after selecting business quotes / recommended rates',
        businessTab:'Create a quote manually (opens rate maintenance; Save & Quote creates a business quote), or submit after selecting supplier quotes / recommended rates'
      },
      messages: {
        loadInquiryFailed: 'Failed to load inquiry detail',
        missingInquiryId: 'Missing inquiry ID; unable to load detail',
        inquiryNotFound: 'Inquiry detail not found',
        loadDetailFailed: 'Failed to load inquiry & quote detail',
        loadRecommendFailed: 'Failed to load recommended rates',
        selectBizOrRecommend: 'Please select at least one business quote or recommended rate',
        selectSupplierOrRecommend: 'Please select at least one supplier quote or recommended rate',
        selectComboOrEcommerce: 'Please select at least one combo or ecommerce rate',
        selectAtLeastOneRate: 'Please select at least one rate',
        missingInquiryIdSubmit: 'Missing inquiry ID; unable to submit quote',
        nothingToSubmit: 'No quotes to submit',
        submitSalesSuccess: 'Submitted {count} sales quote(s)',
        submitBusinessSuccess: 'Submitted {count} business quote(s)',
        submitSalesFailed: 'Failed to submit sales quote',
        submitBusinessFailed: 'Failed to submit business quote',
        generateSalesSuccess: 'Generated {count} sales quote(s)',
        inquireBusinessSuccess: 'Inquiry sent to business',
        inquireSupplierSuccess: 'Inquiry sent to {count} supplier contact(s)',
        inquireBusinessFailed: 'Failed to inquire business',
        inquireSupplierFailed: 'Failed to inquire supplier',
        selectBusinessFirst: 'Please select business staff before inquiring',
        selectSupplierContactFirst: 'Please select at least one supplier contact before inquiring',
        selectSupplierFirst: 'Please select a supplier before inquiring',
        missingInquiryIdCreateRate: 'Missing inquiry ID; unable to create rate',
        missingInquiryIdInquire: 'Missing inquiry ID; unable to start inquiry',
        missingQuoteIdImport: 'Missing quote ID; unable to import to rate library',
        importModeNotReady: 'Import to rate library is not available for mode ({mode}) yet',
        consultationStarted: 'Consultation started',
        consultationSent: 'Consultation request sent',
        consultationFailed: 'Failed to start consultation',
        enterExpectedPrice: 'Please enter expected price',
        missingQuoteIdConsult: 'Missing valid quote ID; unable to start consultation',
        selectQuoteToConsult: 'Please select a quote to consult',
        supplierConfirmed: 'Supplier confirmed',
        confirmSupplierFailed: 'Failed to confirm supplier',
        selectValidSupplierQuote: 'Please select a valid supplier quote',
        loadSailingsFailed: 'Failed to load sailings',
        noTrunkForSailing: 'This combo has no main-leg rate; unable to query sailings',
        loadShelfRatesFailed: 'Failed to load published rates',
        enterMarkupAmount: 'Please enter markup amount first',
        enterMarkupAmountPerBox: 'Please enter markup amount (USD/box)',
        enterMarkupAmountShort: 'Please enter markup amount',
        quickMarkupBoth: 'Quick markup applied (small +25 / large +50, ticket +25)',
        quickMarkupBox: 'Quick markup applied (small +25 / large +50)',
        quickMarkupKg: 'Quick markup applied (+25 per kg)',
        quickMarkupTicket: 'Quick markup applied (+25 per ticket)',
        quickMarkupGlobal: 'Quick markup applied (small +25 / large +50, ticket +25)',
        applyMarkupKg: 'Applied markup USD {amt}/kg to "{label}"',
        applyMarkupBoxTicket: 'Applied markup USD {amt}/box (ticket) to "{label}"',
        applyMarkupBox: 'Applied markup USD {amt}/box to "{label}"',
        applyMarkupTicket: 'Applied markup USD {amt}/ticket to "{label}"',
        applyMarkupBoxDone: 'Markup applied (USD {amt}/box)',
        weightMarkup: 'Weight-band markup{amt}',
        weightMarkupSpaced: 'Weight-band markup {amt}',
        noMarkupRows: 'No fee rows available for markup',
        noBoxMarkupRows: 'No per-box fee rows available for markup',
        reQuoteNoFees: 'No fee details; cannot confirm quote',
        reQuoteNothing: 'No fee details to submit',
        reQuoteMissingId: 'Missing valid quote ID; unable to submit quote confirmation',
        reQuoteSuccess: 'Quote confirmation submitted; consultation status updated to Completed',
        reQuoteFailed: 'Failed to confirm quote',
        selectQuoteFirst: 'Please select a quote first',
        inquiryAlreadyOrdered: 'This inquiry already has an order; cannot book again',
        quoteMissingForBooking: 'Quote not found; unable to start booking',
        bookingConfirmFailed: 'Failed to confirm booking',
        selectSupplierQuoteToConfirm: 'Please select a supplier quote to confirm',
        noConfirmedSupplierQuote: 'No confirmed supplier quote',
        cannotCancelImported: 'Already imported to rate library; cannot cancel confirmation',
        cancelConfirmSuccess: 'Confirmation cancelled',
        cancelConfirmFailed: 'Failed to cancel supplier confirmation',
        confirmImportOk: 'Confirm Import',
        confirmImportSchemeContent: 'Import "{scheme}" from "{supplier}" into the rate library?{costPart} An FCL draft will be created from quote fees.',
        confirmImportCostPart: ' All-in cost: {cost}.',
        cancelConfirmContent: 'Cancel the current supplier confirmation?',
        missingInquiryIdValid: 'Missing valid inquiry ID'

      },
      supplier: {
        sentSuppliers: 'Sent Suppliers',
        quoteTable: 'Supplier Quotes',
        quotedCount: '{quoted}/{total} quoted',
        confirmSupplier: 'Confirm Supplier',
        cancelConfirmSupplier: 'Cancel Confirmation',
        noQuotes: 'No quotes yet',
        waitingQuotes: 'Inquiry sent to {count} suppliers, waiting for quotes...'
      },
      customer: {
        title: 'Customer',
        analysis: 'Customer Analysis',
        followUp: 'Quote Follow-up',
        noAnalysis: 'No customer analysis data',
        noFollowUp: 'No follow-up records'
      },

      labels: {
        status: 'Status',
        supplier: 'Supplier',
        schemeName: 'Scheme',
        supplierQuoteNo: 'Supplier Quote No.',
        carrier: 'Carrier',
        voyageDays: 'Transit',
        voyageDaysWithUnit: 'Transit (Days)',
        voyageHoursWithUnit: 'Transit (Hours)',
        prePortFee: 'Pre-carriage Fee',
        trunkFee: 'Main-leg Fee',
        lastMileFee: 'On-carriage Fee',
        totalFee: 'All-in Cost',
        validity: 'Validity',
        quoteTime: 'Quote Time',
        confirmStatus: 'Confirmation',
        consultationStatus: 'Consultation',
        importStatus: 'Import Status',
        negotiate: 'Negotiate',
        actions: 'Actions',
        basicInfo: 'Basic Info',
        currency: 'Currency',
        currencyShort: 'Currency',
        serviceType: 'Service Type',
        trunkFreight: 'Main-leg Freight',
        feeItem: 'Fee Item',
        feeName: 'Fee Name',
        fee: 'Fee',
        boxType: 'Container Type',
        unitPrice: 'Unit Price',
        quantity: 'Qty',
        subtotal: 'Subtotal',
        billingUnit: 'Billing Unit',
        remark: 'Remarks',
        remarkColon: 'Remarks: ',
        unit: 'Unit',
        expectedPrice: 'Expected Price',
        expectedPriceColon: 'Expected Price: ',
        consultNote: 'Consultation Notes',
        consultNoteColon: 'Notes: ',
        changeContentColon: 'Changes: ',
        pol: 'POL',
        pod: 'POD',
        rateSource: 'Rate Source',
        vesselVoyage: 'Vessel / Voyage',
        routeCode: 'Route Code',
        boxOwner: 'Container Owner',
        commodity: 'Commodity',
        segTotal: 'Segment Total',
        notCountTotal: 'Excluded from Total',
        chargeUnit: 'Billing Unit',
        pricingMode: 'Pricing Mode',
        select: 'Select',
        vessel: 'Vessel',
        voyage: 'Voyage',
        lane: 'Lane',
        departureFreq: 'Sailing Frequency',
        customsCutoff: 'Customs Cutoff',
        portCutoff: 'Port Cutoff',
        space: 'Space',
        inquiryTotalLabel: 'Inquiry Total',
        sellTotalTimesQty: 'Sell Total × Qty',
        origTotalColon: 'Original Total: ',
        quoteTotalColon: 'Quote Total: ',
        sellTotalColon: 'Sell Total: ',
        costTotalColon: 'Cost Total: ',
        sellPriceSuffix: '{ct} Sell',
        costPriceSuffix: '{ct} Cost',
        segTotalColon: '{seg} Total: ',
        feeDetail: 'Fee Details',
        inquiryBoxUnitTotal: 'Inquiry Box Unit / Qty Total',
        trunkSegInquiryPrice: 'Main-leg Inquiry Box Prices (Ocean / Base)',
        trunkFeeDetail: 'Main-leg Fee Details (incl. surcharges, original currency)',
        scheduleInfo: 'Sailing Info',
        laneCodeTag: 'Lane {code}',
        voyageDaysTag: 'Transit {days} days',
        voyageHoursTag: 'Transit {hours} hours',
        validityColon: 'Validity: ',
        validityRange: '{from} to {to}',
        days: '{n} days',
        daysCompact: '{n}d',
        dateRange: '{from} ~ {to}',
        currentQuoteUsd: 'Current Quote USD {amount}',
        none: 'None',
        originalPrice: 'Original',
        quotePrice: 'Quote',
        sellPrice: 'Sell Price',
        salesQuote: 'Sales Quote',
        subtotalUsd: 'Subtotal (USD)',
        mBand: 'M Band',
        mBandMinPerTicket: 'Min charge · per ticket',
        hitBand: 'Hit Band ({label})',
        chargeableWeight: 'Chargeable {weight}',
        ticketOrig: 'Fee (Ticket)',
        ticketOrigPrice: 'Original',
        ticketQuotePrice: 'Quote',
        boxSubtotal: 'Box Subtotal',
        total: 'Total',
        usdPerBox: 'USD/box',
        pricingByBox: 'By Container',
        airTrunk: 'Air Main Leg',
        surchargeColon: 'Surcharges: ',
        remarkContentColon: 'Remarks: ',
        defaultChecked: 'Default On',
        contactColon: 'Contact: ',
        quoteTimeColon: 'Quoted At: ',
        templateColon: 'Template: {name}',
        weightLimit: 'Weight Limit',
        volumeWeightFactor: 'Vol. Weight Factor',
        freeDemurrageDays: 'Free Demurrage Days',
        flightNo: 'Flight No.',
        detention: 'Detention',
        demurrage: 'Demurrage',
        loadingPlaceInfo: 'Loading Place Info',
        originPlaceInfo: 'Origin Info',
        pickupAddressInfo: 'Pickup Address Info',
        destPlaceInfo: 'Destination Info',
        storeAddress: 'Store Address',
        bargeCarrier: 'Barge Carrier',
        loadingPort: 'Loading Port',
        bargeVessel: 'Barge Vessel',
        bargeVoyage: 'Barge Voyage',
        expectedDeparture: 'ETD',
        expectedArrival: 'ETA',
        bargeVoyageDays: 'Barge Transit',
        loadingStation: 'Loading Station',
        routeCategory: 'Route Category',
        trainNo: 'Train No.',
        departureTime: 'Departure Time',
        addressType: 'Address Type',
        originTerminal: 'Origin Terminal',
        railwayStation: 'Rail Station',
        originAirport: 'Origin Airport',
        airportCargoStation: 'Airport Cargo Station',
        unloadTerminal: 'Discharge Terminal',
        unloadStation: 'Discharge Station',
        unloadAirport: 'Discharge Airport',
        thirdPartyAddress: 'Third-party Address',
        warehouseAddress: 'Warehouse Address',
        destTerminal: 'POD Terminal',
        bargeDepartureTime: 'Barge ETD',
        bargeArrivalTime: 'Barge ETA',
        directFly: 'Direct Flight',
        feeType: 'Fee Type',
        paymentTerms: 'Payment Terms',
        weightSegment: 'Weight Band',
        airMShow: 'Air freight: M display',
        minCharge: 'Min Charge',
        maxCharge: 'Max Charge',
        costTotal: 'Cost Total',
        sellTotal: 'Sell Total',
        inquiryBoxType: 'Inquiry Box Type',
        prePortSegTitle: '📍 Pre-carriage',
        trunkSegTitle: '🚢 Main Leg',
        lastMileSegTitle: '📍 On-carriage',
        remarkContent: 'Remarks',
        smartMarkup: 'Smart Markup',
        apply: 'Apply',
        close: 'Close',
        cancel: 'Cancel',
        send: 'Send',
        confirm: 'Confirm',
        back: 'Back',
        completed: 'Completed'
      },
      status: {
        pending: 'Pending Quote',
        quoted: 'Quoted',
        rejected: 'Rejected',
        confirmed: 'Confirmed',
        unconfirmed: 'Unconfirmed',
        imported: 'Imported',
        notImported: 'Not Imported',
        consulting: 'In Consultation',
        notConsulted: 'Not Consulted'
      },
      units: {
        box: 'Box',
        ticket: 'Ticket',
        day: 'Day',
        days: '{n} days',
        daysCompact: '{n}d',
        perBox: 'Per Container',
        kg: 'kg',
        households: '{count}',
        countItems: '{count} items'
      },
      fees: {
        oceanFreight: 'Ocean Freight',
        oceanSurcharge: 'Ocean Surcharge',
        originPortFee: 'POL Fees',
        destPortFee: 'POD Fees',
        other: 'Other',
        prePortFreight: 'Pre-carriage Freight',
        prePortSurcharge: 'Pre-carriage Surcharge',
        prePortOther: 'Pre-carriage Other',
        lastMileFreight: 'On-carriage Freight',
        lastMileSurcharge: 'On-carriage Surcharge',
        lastMileOther: 'On-carriage Other',
        feeItem: 'Fee Item',
        fee: 'Fee',
        airFreight: 'Air Freight',
        railFreight: 'Rail Freight',
        airTrunkSurcharge: 'Main-leg Surcharge',
        airOriginFee: 'Origin Fees',
        airDestFee: 'Destination Fees',
        railSurcharge: 'Rail Surcharge',
        freight: 'Freight',
        prePortFee: 'Pre-carriage Fee',
        lastMileFee: 'On-carriage Fee',
        totalFee: 'All-in Cost',
        trunkFreight: 'Main-leg Freight'
      },
      sort: {
        smart: 'Smart Recommend',
        inquiryTotal: 'Inquiry Total',
        voyageDays: 'Transit',
        label: 'Sort'
      },
      combo: {
        precise: 'Precise Combo',
        free: 'Free Combo',
        totalCost: 'All-in Cost',
        prefillTip: 'Inquiry includes pre/trunk/last-mile segments; combo filters prefilled from POL/POD/carrier. Select a combo.',
        prefillTipAir: 'Inquiry includes pre/trunk/last-mile segments; combo filters prefilled from origin airport, destination airport and airline. Select a combo.',
        linkedTip: 'Intermodal combos matched to inquiry; select to submit',
        scheduleTip: 'Selected sailings will be submitted with the combo',
        viewSchedule: 'View Sailings'
      },
      ratePicker: {
        selectedCount: '{count} rate(s) selected',
        fclTip: '{count} rate(s) selected; only inquiry box types shown; inquiry total uses inquiry qty; expand View Sailings to pick sailings',
        allIn: 'Quote all-in (no fee breakdown)',
        submitBizInquiry: 'Submit Business Inquiry',
        titleWithMode: 'Select Rate · {mode}',
        title: 'Select Rate',
        specialBoxWarn: 'Inquiry has special box types (reefer/OT etc.) without standard rates; excluded from inquiry total',
        ecommerceLatest: 'Ecommerce Rates',
        ecommerceLatestSub: '(latest sailing prices)',
        recommendOfflineTop: '(top {count}, lowest sum of 4 box types)',
        recommendMatchSub: 'Match by inquiry origin country/city/port → rate POL; discharge country/city/port → rate POD',
        recommendMatchSubAir: 'Match by inquiry origin country/city/airport → rate origin airport; destination country/city/airport → rate destination airport',
        modes: {
          combined: 'Combined',
          fcl: 'FCL Rates',
          lcl: 'LCL Rates',
          air: 'Air Rates',
          rail: 'Rail Rates',
          express: 'Express Rates',
          preport: 'Pre-carriage Rates',
          lastmile: 'On-carriage Rates',
          roro: 'RoRo Rates',
          bulk: 'Bulk Rates'
        },
        modeShort: {
          air: 'Air',
          rail: 'Rail',
          trunk: 'Main Leg'
        },
        lclPrice: 'LCL:${price}/{unit}'
      },
      modals: {
        schemeDetail: 'Quote Detail - {name}',
        startConsultation: 'Start Consultation',
        negotiationHistory: 'Negotiation History',
        salesDetail: 'Sales Quote Detail',
        businessDetail: 'Business Quote Detail',
        recommendDetail: 'Recommended Rate Detail',
        comboDetail: 'Combo Rate Detail',
        viewSchedule: 'View Sailings',
        reQuote: 'Confirm Quote — {no}',
        confirmQuote: 'Confirm Quote (by inquiry box qty)',
        confirmQuoteByUnit: 'Confirm Quote (by billing unit)',
        confirmImport: 'Confirm Import to Rate Library',
        cancelConfirmSupplier: 'Cancel Supplier Confirmation'
      },
      confirmQuote: {
        srcBiz: 'Business Quote',
        srcSupplier: 'Supplier Quote',
        srcCombined: 'Combo Quote',
        srcEcommerce: 'Ecommerce Rate',
        srcRate: 'Rate Library / Recommend',
        perBoxMarkup: 'Per box +25/+50',
        smartDesc: 'Enter a custom markup; it applies to ocean freight rows (markup = original + amount), then fine-tune per fee row',
        smartHint: 'Markup applies to ocean freight rows; you can fine-tune per fee row',
        generate: 'Generate Quote',
        remarkPickup: 'Pickup Notes',
        remarkOverweight: 'Overweight Notes',
        remarkFreeDays: 'Free Days',
        remarkOther: 'Other Notes',
        phPickup: 'Special pickup notes',
        phOverweight: 'Overweight notes',
        phFreeDays: 'Free detention at POD X days',
        phOther: 'Other notes',
        freeDaysValue: 'Free detention at POD {days} days',
        footerCombo: 'After confirming combo segments, one aggregated combo quote is generated; quote price = sum of marked-up segments',
        footerBizExtra: 'Business base prices generated per row',
        footerSupplierExtra: 'Supplier base prices generated per row',
        footerMixed: 'Mixed quote: {labels} generate quotes; quote price = marked-up total above',
        footerBiz: 'After generation, sales sell = weighted business total; quote price = marked-up total',
        footerSupplier: 'After generation, business cost = supplier cost; quote price = marked-up total',
        footerRateBiz: 'After generation, business cost = inquiry weighted total; quote price = marked-up total',
        footerRateSales: 'After generation, sales sell = inquiry weighted total; quote price = marked-up total',
        labelBizBase: 'Business base',
        labelSupplierBase: 'Supplier base',
        labelRateLib: 'Rate library / recommended',
        reQuoteHint: 'Submitting creates a new consultation record; status becomes Completed',
        reQuoteRemarkPh: 'Confirmation remarks (pickup, overweight, free days, etc.; shown to customer)',
        reQuoteSubmit: 'Submit Confirmation',
        quoteTotalWithBase: 'Quote total {total}; base USD {base}',
        quoteTotalUsdWithBase: 'Quote total USD {quote}; base USD {base}',
        airHitRemark: 'Chargeable weight hit band {label}',
        airMOrig: '; M-band min original {orig}',
        airMQuote: ' / quote {quote}',
        perTicket: 'Per Ticket'
      },
      supplierExtra: {
        sentCount: 'Sent Suppliers ({count})',
        unlinked: 'Unlinked Supplier',
        schemeFallback: 'Quote Scheme',
        noSalesQuoteHint: 'No sales quote yet. Use "Select Rate" above to quote',
        noBusinessQuoteHint: 'No business quote yet. Create manually or inquire suppliers',
        inquiryNotFound: 'Inquiry for this quote was not found',
        localTrailer: 'Local trucking provider',
        localDelivery: 'Local delivery provider',
        demoSalesQuoter: 'Sales Demo',
        prePortCostTag: 'Pre {amount}',
        lastMileCostTag: 'On-carriage {amount}',
        surchargeCostTag: 'Surcharge {amount}',
        supplierFallback: 'Supplier'
      },
      apiSegments: {
        prePort: '港前段',
        trunk: '干线段',
        lastMile: '尾程段'
      },
      apiStatus: {
        spaceAvailable: '有空',
        spaceTight: '紧张',
        consulting: '磋商中',
        completed: '完成',
        expectedPrice: '期望价格',
        expectedPriceLine: '期望价格：{price}',
        consultNote: '磋商说明',
        consultNoteLine: '磋商说明：{note}',
        expectedAndNote: '期望价格：{price}\n磋商说明：{note}'
      },
      apiFeeMatch: {
        oceanFreight: '海运费',
        surcharge: '附加',
        destPort: '目的港',
        originPort: '起运港',
        docFee: '单证费',
        fileFee: '文件费',
        freight: '运费',
        kg: '公斤',
        kgAlt: '千克'
      },
      apiCarrierAlias: {
        cosco: 'COSCO',
        maersk: 'Maersk',
        msc: 'MSC',
        one: 'ONE',
        cma: 'CMA CGM',
        evergreen: 'Evergreen',
        hpl: 'Hapag-Lloyd',
        whl: 'Wan Hai',
        yml: 'Yang Ming'
      },
      placeholders: {
        expectedPrice: 'Enter expected price, e.g. USD 2500',
        consultNote: 'Enter consultation notes, e.g. items to adjust and reasons'
      },

      empty: {
        noRecommend: 'No matching recommended rates',
        noData: 'No data',
        noMatch: 'No match',
        noShelfRates: 'No published rates',
        noComboData: 'No matching data. Submit a business inquiry',
        noSailings: 'No matching sailings',
        noNegotiation: 'No consultation records',
        noTrunkFee: 'No trunk fee details'
      }
    },

    quoteTable: {
      salesQuoteNo: 'Sales Quote No.',
      businessQuoteNo: 'Business Quote No.',
      actions: 'Actions',
      viewDetail: 'View Detail',
      negotiate: 'Negotiate',
      negotiationHistory: 'Negotiation History',
      priceDetails: 'Price Details',
      selectedSailings: 'Selected Sailings',
      boxType: 'Container Type',
      oceanFreight: 'Ocean Freight',
      surcharge: 'Surcharge',
      originalPrice: 'Original',
      quotePrice: 'Quote',
      cost: 'Cost',
      sellPrice: 'Sell',
      direct: 'Direct',
      directFly: 'Direct Flight',
      viaTransit: 'Via {port}',
      transitFallback: 'Transit',
      sailingDepart: 'ETD',
      consultationStatus: 'Consultation Status',
      orderIntention: 'Order Intention',
      directTransit: 'Direct / Transit',
      directFlyTransit: 'Direct / Transit Flight',
      quoteTime: 'Quote Time',
      validity: 'Validity',
      prePortAddress: 'Pre-carriage Address',
      lastMileAddress: 'On-carriage Address',
      airline: 'Airline',
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      transitAirport: 'Transit Airport',
      railCompany: 'Rail Company',
      originStation: 'Origin Station',
      destStation: 'Destination Station',
      exitPort: 'Exit Border',
      entryPort: 'Entry Border',
      transitStation: 'Transit Station',
      containerOwner: 'Container Owner',
      loadingPlace: 'Loading Place',
      transportMode: 'Transport Mode',
      originPlace: 'Origin',
      pickupAddress: 'Pickup Address',
      destAddress: 'Destination Address',
      carrier: 'Carrier',
      placeOfReceipt: 'Place of Receipt',
      pol: 'POL',
      unloadPort: 'Discharge Port',
      pod: 'POD',
      transitPort: 'Transit Port',
      loadingTerminal: 'POL Terminal',
      dischargeTerminal: 'POD Terminal',
      vessel: 'Vessel',
      voyage: 'Voyage',
      routeCode: 'Route Code',
      sellTotalUsd: 'Sell Total (USD)',
      prePortTransportMode: 'Pre-carriage Mode',
      lastMileTransportMode: 'On-carriage Mode',
      segmentOrigQuote: '{segment} Original / Quote Total',
      segmentCostSell: '{segment} Cost / Sell Price',
      segmentPrePort: 'Pre-carriage',
      segmentTrunk: 'Main Leg',
      segmentLastMile: 'On-carriage',
      consultationNone: 'Not Consulted',
      consultationInProgress: 'In Consultation',
      consultationDone: 'Consultation Completed',
      intentionYes: 'Interested',
      intentionNo: 'Not Interested',
      intentionConsidering: 'Considering',
      intentionOrder: 'Intent Order'
    },

    recommendedRates: {
      empty: 'No matching rates',
      carrier: 'Carrier',
      route: 'POL / POD',
      validity: 'Validity',
      inquiryTotal: 'Inquiry Total',
      segment: 'Segment',
      loadingPort: 'POL',
      destinationPort: 'POD',
      carrierOrProvider: 'Carrier / Provider',
      containerType: 'Container Type',
      price: 'Rate',
      currency: 'Currency',
      voyageDays: 'Transit (Days)',
      dataSourceEcommerce: 'Ecommerce',
      dataSourceOffline: 'Offline',
      dataSourceCargoware: 'Cargoware',
      shelfOn: 'Published',
      shelfOff: 'Unpublished',
      ecommerceReason: 'Ecommerce Rate',
      ecommerceTitle: 'Latest ecommerce price with competitive quote',
      cargowareMeta: 'Ocean payable · {count} order(s)',
      cargowareMetaWithPeriod: 'Ocean payable · {count} order(s) · {period}',
      fclBox: 'FCL'
    }
  }
}
